module.exports = __webpack_public_path__ + "static/img/lxwm_banner@2x.c911287.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/lxwm_banner@2x.png
// module id = qLDV
// module chunks = 0